import clsx from "clsx";
import {Paragraph} from "@digdir/designsystemet-react";


export function Medal({rank}: { rank: number }) {
    return (
        <div className="h-fit w-fit">
            <div
                className={clsx(
                    "relative size-[40px] rounded-full  overflow-hidden flex items-center justify-center",
                    {"border-[5px] border-[#EFD474]": rank === 1},
                    {"border-[5px] border-[#DCD2D3]": rank === 2},
                    {"border-[5px] border-[#FFB36C]": rank === 3},
                )}>
                <div className="absolute inset-0 bg-white"/>
                <div className={clsx("absolute inset-0",
                    {"bg-[#EFD47433]": rank === 1},
                    {"bg-[#F8F1F2]": rank === 2},
                    {"bg-[#FFB36C33]": rank === 3})}/>
                <Paragraph data-size={"xs"}
                           className="relative z-10 !mb-0 text-neutral-text-default">{rank}</Paragraph>
            </div>
        </div>
    )
}